/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectStatus = {
    AcceptanceBlocked: 'ACCEPTANCE_BLOCKED',
    Canceled: 'CANCELED',
    Delivered: 'DELIVERED',
    Ended: 'ENDED',
    InProgress: 'IN_PROGRESS',
    PaymentOnHold: 'PAYMENT_ON_HOLD',
    PreApproved: 'PRE_APPROVED',
    ToApprove: 'TO_APPROVE',
    Upcoming: 'UPCOMING'
} as const;
export type ProjectStatus = typeof ProjectStatus[keyof typeof ProjectStatus];


export function instanceOfProjectStatus(value: any): boolean {
    for (const key in ProjectStatus) {
        if (Object.prototype.hasOwnProperty.call(ProjectStatus, key)) {
            // @ts-ignore
            if (ProjectStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectStatusFromJSON(json: any): ProjectStatus {
    return ProjectStatusFromJSONTyped(json, false);
}

export function ProjectStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectStatus {
    return json as ProjectStatus;
}

export function ProjectStatusToJSON(value?: ProjectStatus | null): any {
    return value as any;
}

